import React from "react";
import PropTypes from "prop-types";

import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { useTheme } from "@mui/material/styles";

const PricingHeader = ({ title, description, light = false, badge }) => {
  const theme = useTheme();

  return (
    <Box
      id="auth-header-box1"
      position="relative"
      sx={{
        overflow: "hidden",
        pt: { xs: 3, md: 5 },
        pb: { xs: 2, md: 3 },
        backgroundColor: light
          ? theme.palette.white.main
          : theme.palette.dark.main,
      }}
    >
      <Container id="auth-header-container1" maxWidth="xl">
        <Box id="auth-header-box2" mb={0} textAlign="center">
          <Box
            id="auth-header-box3"
            component={Grid}
            container
            justifyContent="center"
            sx={{
              color: light
                ? theme.palette.dark.main
                : theme.palette.white.main,
              pt: 0,
            }}
          >
            <Grid item xl={10} lg={10} xs={12}>
              {badge && (
                <Box
                  display="inline-flex"
                  alignItems="center"
                  sx={{
                    px: "0.75rem",
                    py: "0.2rem",
                    borderRadius: "20px",
                    backgroundColor: theme.palette.primary.extraLight,
                    // extraDark, not main: the badge is small uppercase text on a
                    // tinted fill, where main measures 3.6:1. Same hue, AA-clear.
                    color: theme.palette.primary.extraDark,
                    mb: "0.5rem",
                    border: "1px solid " + theme.palette.primary.light,
                  }}
                >
                  <Typography
                    variant="body2"
                    sx={{
                      fontWeight: 800,
                      fontSize: "0.7rem",
                      textTransform: "uppercase",
                      letterSpacing: 1,
                    }}
                  >
                    {badge}
                  </Typography>
                </Box>
              )}

              {title && (
                <Typography
                  component="h1"
                  variant="h1"
                  color="inherit"
                  sx={{ fontSize: "1.75rem", fontWeight: 800 }}
                >
                  {title}
                </Typography>
              )}

              {description && (
                <Box
                  component="p"
                  sx={{
                    color: light
                      ? theme.palette.gray[700]
                      : "rgba(255,255,255,0.8)",
                    lineHeight: 1.3,
                    fontSize: "0.85rem",
                    mt: "0.25rem",
                  }}
                >
                  {description}
                </Box>
              )}
            </Grid>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

PricingHeader.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  badge: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  light: PropTypes.bool,
};

export default PricingHeader;
